// extracted by css-extract-rspack-plugin
export default {"cls1":"Loading-cls1_W9x","cls2":"Loading-cls2_Xvu Loading-cls1_W9x","small":"Loading-small_WfE"};